import { render, staticRenderFns } from "./LclDangerList.vue?vue&type=template&id=e88fd508&scoped=true"
import script from "./LclDangerList.vue?vue&type=script&lang=js"
export * from "./LclDangerList.vue?vue&type=script&lang=js"
import style0 from "./LclDangerList.vue?vue&type=style&index=0&id=e88fd508&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88fd508",
  null
  
)

export default component.exports